module.exports = __webpack_public_path__ + "static/media/CoreA1_negativo.0f1670a5.png";